import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "auto",
  },
}));

const MasterLayoutContainer = (props) => {
  const classes = useStyles();
  return <Box className={classes.container}>{props.children}</Box>;
};

export default MasterLayoutContainer;
